import { useMemo } from "react";
import {
  InternalAdminUserQuery,
  InternalAdminUserQueryVariables,
} from "gql/graphql";
import { useQuery } from "@apollo/client";
import INTERNAL_ADMIN_USER_QUERY from "../_networking/internal-admin-user";

const useInternalAdminUsers = (id: string | string[] | undefined) => {
  const isValid = (Array.isArray(id) && id.length > 0) || !!id;

  const { data, loading } = useQuery<
    InternalAdminUserQuery,
    InternalAdminUserQueryVariables
  >(INTERNAL_ADMIN_USER_QUERY, {
    fetchPolicy: "network-only",
    variables: id
      ? {
          id,
        }
      : undefined,
    skip: !isValid,
  });

  const users = useMemo(() => {
    if (!data) return [];
    return data.internalAdminUser;
  }, [data]);

  const user = useMemo(() => {
    if (users && users.length === 1) {
      return users[0];
    }
    return undefined;
  }, [users]);

  return {
    user,
    users,
    loading,
  };
};

export default useInternalAdminUsers;
